<div id="speiseplanTagIcons">
  <mat-icon class="icons" id="tagBestellt" *ngIf="bestellt && !bearbeitet">check</mat-icon>
  <mat-icon class="icons" id="tagBearbeitet" *ngIf="bearbeitet">edit</mat-icon>
</div>
